import { render, staticRenderFns } from "./Result-Touch.vue?vue&type=template&id=f7a51d00&scoped=true"
import script from "./Result-Touch.vue?vue&type=script&lang=js"
export * from "./Result-Touch.vue?vue&type=script&lang=js"
import style0 from "./Result-Touch.vue?vue&type=style&index=0&id=f7a51d00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a51d00",
  null
  
)

export default component.exports